'use strict';

const VIEW_REGISTRY = window.BACKBONE_VIEW_REGISTRY = {};

export function attachBackboneViewDebugHelpers(Backbone) {
  const _setElement = Backbone.View.prototype.setElement;
  Backbone.View.prototype.setElement = function(element) {
    _setElement.apply(this, arguments);
    if (!this.el) return this;
    this.el.attachedBackboneViews = this.el.attachedBackboneViews || {};
    this.el.attachedBackboneViews[this.cid] = this;
    this.el.setAttribute(
      'backbone-view',
      Object.keys(this.el.attachedBackboneViews).join(',')
    );
    VIEW_REGISTRY[this.cid] = this;
    return this;
  };

  const _remove = Backbone.View.prototype.remove;
  Backbone.View.prototype.remove = function() {
    _remove.apply(this, arguments);
    if (VIEW_REGISTRY && VIEW_REGISTRY[this.cid]) {
      delete VIEW_REGISTRY[this.cid];
    }
    if (this.el.attachedBackboneViews && this.el.attachedBackboneViews[this.cid]) {
      delete this.el.attachedBackboneViews[this.cid];
    }
    return this;
  }
}



// WEBPACK FOOTER //
// ./assets/utilities/backboneDebugHelpers.js